import { render, staticRenderFns } from "./SupportUpdate.vue?vue&type=template&id=0a3df324&scoped=true&"
import script from "./SupportUpdate.vue?vue&type=script&lang=js&"
export * from "./SupportUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3df324",
  null
  
)

export default component.exports